(() => {
  const syncInstagramFallback = () => {
    const feed = document.querySelector('[id$="__pearhaus_instagram"] #insta-feed');
    const fallback = document.querySelector('[id$="__pearhaus_instagram_fallback"]');

    if (fallback) fallback.hidden = Boolean(feed?.children.length);
  };

  syncInstagramFallback();
  new MutationObserver(syncInstagramFallback).observe(document.documentElement, { childList: true, subtree: true });
})();
